/****************
 * THE ADDRESSES OUR ORDERS LEAVE FROM. ONE LIST, BOTH APPS. 2026-10-10.
 *
 * A broker key may be restricted to a list of addresses, and a key restricted
 * to the wrong ones does not degrade: the broker refuses every order with "IP
 * mismatch". Guillaume, 2026-10-10: orders leave from three addresses, and the
 * user allowlists all three at once, copied in one click:
 *
 *   80.241.220.163   the app server itself (direct, the fastest route)
 *   151.145.203.216  our relay at Exoscale, Switzerland (outlives a server move)
 *   92.113.241.38    one Webshare proxy kept for orders only (Singapore)
 *
 * The backend sends an order through the first route that works and moves a
 * refused one to the next (internal/egress); a key that lists all three never
 * sees "IP mismatch" whichever route carried the order.
 *
 * Byte-identical in frontend/src/lib and mobile-app/src/lib (the phone's copy
 * is written by scripts/sync-mobile-locales.mjs, never by hand). The Orb's
 * knowledge documents name the same addresses; tradingIps.test.ts fails the
 * build if any of them disagrees, or if a translation spells one out.
 ****************/

/** Our relay at Exoscale, Switzerland (zone CH-DK-2), created 2026-10-10. */
const EXOSCALE_RELAY = '151.145.203.216';

/** The addresses, in the order the backend tries them. */
export const TRADING_IPS: readonly string[] = ['80.241.220.163', EXOSCALE_RELAY, '92.113.241.38'].filter(
  (ip) => ip !== '',
);

/**
 * What the copy button puts on the clipboard: the addresses separated by commas,
 * no spaces, which is what Phemex's "Bind IP" field takes.
 */
export function tradingIpsForClipboard(ips: readonly string[] = TRADING_IPS): string {
  return ips.join(',');
}

/*
 * Validated, because a mistyped address is indistinguishable from a correct one
 * at a glance and would reach every user.
 */
export function isIpv4(s: string): boolean {
  const parts = s.split('.');
  if (parts.length !== 4) return false;
  return parts.every((p) => {
    if (!/^\d{1,3}$/.test(p)) return false;
    const n = Number(p);
    // No leading zeros: "01" is not how an address is written, and accepting it
    // hides a copy-paste that truncated something.
    if (p.length > 1 && p[0] === '0') return false;
    return n >= 0 && n <= 255;
  });
}
